import React, { useState, useEffect } from "react";

// style //
import "./AddDocuments.css";
import Form from "react-bootstrap/Form";

// Hooks //
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Image //
import { images } from "../../assets/index";

// Components  //
import {
  FormInput,
  ButtonComp,
  PageHeading,
} from "../../common/components/index";
import { FileUploader } from "react-drag-drop-files";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

// API's //
import { getSingleDocumentApi, updateDocumentApi } from "../../api/inductionAndDocumentation"
import { useParams } from 'react-router';

// Actions //
import {
  receivedError,
  requestSent,
  responseRecived,
} from "../../redux/actions/utilsActions";
import { getSiteProjectApi } from "../../api/siteProjectApi";

const EditDocuments = () => {
  const { id } = useParams()
  const { loading } = useSelector((state) => state.utils);
  const fileTypes = ["PDF"];

  // Hooks //
  const [formData, setFormData] = useState({
    name: "",
    document: "",
    site_id: null
  });
  const navigate = useNavigate();
  const [siteList, setSiteList] = useState([])
  const [selectedSite, setSelectedSite] = useState({})
  const [respMessage, setRespMessage] = useState('')
  const [modalShow, setModalShow] = useState(false)
  const { userToken } = useSelector((state) => state.user)
  const [error, setError] = useState('')

  const dispatch = useDispatch();

  // API Calls //
  const getSiteProjectData = async () => {
    try {
      dispatch(requestSent());
      const data = await getSingleDocumentApi(userToken, id);
      setFormData({
        name: data.data.name,
        site_id: data.data.site_id
      });
      await getSites(data.data.site_id);
      dispatch(responseRecived());
    } catch (error) {
      dispatch(receivedError(error));
    }
  };

  const getSites = async (site_id) => {
    try {
      const data = await getSiteProjectApi(userToken, {
        page: 1,
        limit: 20,
      });
      const defaultSite = data.data.rows.find(s => s.id === site_id);
      if (defaultSite) {
        setSelectedSite({
          id: site_id,
          reference: defaultSite.reference,
          name: defaultSite.name
        });
      }
      setSiteList(data.data.rows)
    } catch (error) {
      throw error;
    }
  }

  // UseEffect //
  useEffect(() => {
    getSiteProjectData();
  }, []);

  // Handlers //
  const handleChange = (file) => {
    setFormData({
      ...formData,
      document: file,
    });
  };

  const editDocumentHendler = async () => {
    try {
      setError('')
      dispatch(requestSent());

      const data = await updateDocumentApi(userToken, {
        ...formData,
        site_document_id: id,
      });
      setRespMessage(data.message)
      dispatch(responseRecived())
      setModalShow(true)
    } catch (error) {
      console.log("Update Document Page error::", error);
      // dispatch(receivedError(error));
      setError(error)
      dispatch(receivedError(error));
    }
  };

  const modalHendler = () => {
    dispatch(receivedError(null));
    setModalShow(false)
    navigate("/induction")
  };

  // Modal //
  const CustomModal = () => {
    return (
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalShow}
      >
        <Modal.Body>
          <div className="allert_img_cont">
            <img src={images.success} alt="" />
            <h2>Document Updated</h2>
            <p>{respMessage}</p>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button className="orange_btn btn_style" onClick={modalHendler}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  };

  return (
    <>
      <CustomModal />
      <PageHeading title={"Induction & Documents : Edit Document"} />
      <div id="add-documents" className="right-sec_cont">
        <div>
          <h2>Document Details</h2>
          <FormInput
            width={"30vw"}
            lable="Document Name"
            placeholder={"Enter Document Name"}
            onchange={(value) =>
              setFormData({
                ...formData,
                name: value,
              })
            }
            value={formData.name}
            type={"text"}
            error={error?.error_key === "name" ? true : false}
          />
          <div className="select_inp form_input_cont">
            <p>Site Ref</p>
            <Form.Select
              className="input"
              onChange={(e) => {
                if (!e.target.value) {
                  setSelectedSite({
                    name: '',
                    id: null,
                    reference: ''
                  })
                } else {
                  const selectedSiteID = siteList[e.target.selectedIndex - 1].id;
                  setFormData(prev => ({
                    ...prev,
                    site_id: selectedSiteID
                  }))
                  setSelectedSite({
                    name: siteList[e.target.selectedIndex - 1].name,
                    id: selectedSiteID,
                    reference: siteList[e.target.selectedIndex - 1].reference
                  })
                }
              }
              }
              value={selectedSite.reference + " " + selectedSite.name}
            >
              <option></option>
              {
                siteList.map(sl => <option id={sl.id} key={sl.id}>{sl.reference + " " + sl.name}</option>)
              }
            </Form.Select>
          </div>
          <div className="drag_and_drop_cont form_input_cont">
            <p>Upload Document</p>
            <div className="drop-here">
              <div className="txt_cont">
                <img src={images.uploadingCloud} alt="" />
                {formData?.document ? (
                  <p className="browse">{formData?.document?.name || formData.document}</p>
                ) : (
                  <>
                    <p>Drag and drop here</p>
                    <p>or</p>
                    <p className="browse">browse</p>
                    <p className="file_type">
                      <b>File Type :</b>
                      {fileTypes.map((item) => (
                        <span key={item}>{item}</span>
                      ))}
                    </p>
                  </>
                )}
              </div>
              <FileUploader
                handleChange={handleChange}
                name="file"
                types={fileTypes}
              />
            </div>
          </div>
          {error ? <p className="err_message">*{error?.error_message}</p> : ''}
          <ButtonComp
            onClick={editDocumentHendler}
            title={"Save Document"}
            width={"30vw"}
            disabled={loading}
          />
        </div>
      </div>
    </>
  );
};

export default EditDocuments;
